/* @flow */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getAllPages } from 'catalog/reducers/pages';
import SelectPageModal from './SelectPageModal';
import CreatePageModal from './CreatePageModal';

type Props = {
  visible: boolean,
  pages: List<CatalogPage>,
  onSelected: (page: CatalogPage) => void,
  onCancel: () => void,
};

type State = {
  addMode: boolean,
};

const mapStateToProps = state => ({
  pages: getAllPages(state),
});

class PageSelector extends Component {
  props: Props;
  state: State;

  constructor(props: Props) {
    super(props);

    this.state = {
      addMode: false,
    };
  }

  toggleAddMode = () => this.setState(state => ({ addMode: !state.addMode }));

  close = () => {
    this.setState(
      {
        addMode: false,
      },
      this.props.onCancel
    );
  };

  render() {
    const { visible, pages, onSelected } = this.props;
    const { addMode } = this.state;

    if (addMode) {
      return (
        <CreatePageModal
          visible={visible}
          onClose={this.close}
          onSelected={onSelected}
          onSwitchMode={this.toggleAddMode}
        />
      );
    } else {
      return (
        <SelectPageModal
          visible={visible}
          pages={pages}
          onClose={this.close}
          onSelected={onSelected}
          onSwitchMode={this.toggleAddMode}
        />
      );
    }
  }
}

export default connect(mapStateToProps)(PageSelector);



// WEBPACK FOOTER //
// ./src/modules/catalog/screens/shared/components/PageSelector.js